import { render, staticRenderFns } from "./bill-camera.vue?vue&type=template&id=5cc98099&"
import script from "./bill-camera.vue?vue&type=script&lang=js&"
export * from "./bill-camera.vue?vue&type=script&lang=js&"
import style0 from "./bill-camera.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports